import { render, staticRenderFns } from "./BusInspectionBaseConfig.vue?vue&type=template&id=4e898020&scoped=true&"
import script from "./BusInspectionBaseConfig.vue?vue&type=script&lang=js&"
export * from "./BusInspectionBaseConfig.vue?vue&type=script&lang=js&"
import style0 from "./BusInspectionBaseConfig.vue?vue&type=style&index=0&id=4e898020&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e898020",
  null
  
)

export default component.exports